import { useQuery } from '@apollo/client';
import { useCountry } from '../../components/CountrySelector';
import { useUser } from '../useUser';
import {
  GET_ORDER_SUMMARY_QUERY,
  GetOrderSummaryQuery,
  GetOrderSummaryQueryVariables
} from './orderSummary.rest';

export const useOrderSummary = (orderNumber: string) => {
  const { country } = useCountry();
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error, refetch } = useQuery<
    GetOrderSummaryQuery,
    GetOrderSummaryQueryVariables
  >(GET_ORDER_SUMMARY_QUERY, {
    variables: { countryCode: country.alpha2Code, orderNumber },
    skip: !orderNumber || !accessToken
  });

  return {
    orderSummary: data?.getOrderSummary.data[0],
    orderItems: data?.getOrderSummary.included,
    loading,
    error,
    refetch
  };
};
